import { useModuleBEM } from "@b2bportal/core-themes";
import { useI18nContext } from "@hopper-b2b/i18n";
import { Perk } from "../Perk";
import { Section, SectionTitle } from "../Section";
import { usePopularCategoriesBanners } from "./hooks";
import styles from "./PopularCategoriesSection.module.scss";

export const PopularCategoriesSection = () => {
  const { t } = useI18nContext();
  const [block, cn] = useModuleBEM(styles, "PopularCategoriesSection");

  const perks = usePopularCategoriesBanners();

  return (
    <Section className={block}>
      <SectionTitle className={cn("title")}>
        {t("home.popularCategories.title")}
      </SectionTitle>
      <div className={cn("container")}>
        <ul className={cn("grid")}>
          {perks.map((perk, index) => (
            <li key={index} className={cn("perk")}>
              <Perk
                iconName={perk.iconName}
                text={perk.text}
                link={perk.link}
              />
            </li>
          ))}
        </ul>
      </div>
    </Section>
  );
};
